/**
 * Naming Glossary: https://www.notion.so/landr/Status-844540f3e7aa4458a6a57580d0559a16
 *
 * distributionBeatportApproved -> Long term feature flag. do not remove.
 * @deprecated Use `FeatureFlags` from root-app instead (except if you need it in Falcor)
 */
var FeatureFlagEnum;
(function (FeatureFlagEnum) {
    FeatureFlagEnum["referenceMastering"] = "M_ReferenceMastering";
    FeatureFlagEnum["distributionBeatportApproved"] = "D_BeatportApproved";
    FeatureFlagEnum["epicWaveforms"] = "M_EpicWaveforms";
    FeatureFlagEnum["libraryWaitzine"] = "L_Waitzine";
})(FeatureFlagEnum || (FeatureFlagEnum = {}));

export { FeatureFlagEnum };
